export const esLocale = {
  order: {
    paymentMethod: {
      cash: 'Efectivo',
      card: 'Débito/Crédito',
      coupon: 'Cupón vale',
    },
  },
};
